<template>
    <div class="tech-works">
        <div class="image"></div>
        <div class="content">
            <div class="title">
                Территория Цифровых Решений <br> теперь на портале ProЗнания
            </div>
            <div class="description">
                Портал ТЦР прекратил свою работу. <br> За актуальными решениями для B2B-клиентов <br> переходите на
                ProЗнания в раздел <br>
                Территория Цифровых Решений
            </div>

            <button class="btn accent" @click="goToProZnania">
                <span>Перейти на ProЗнания</span>
            </button>
        </div>

    </div>
</template>

<script>
export default {
    name: 'TechWorks',
    computed: {},
    methods: {
        goToProZnania() {
            window.location = 'https://pro-znaniya.rt.ru/';
        },
    },
};
</script>

<style lang="scss" scoped>
.tech-works {
    width:           100vw;
    height:          100vh;
    display:         flex;
    justify-content: center;
    text-align:      center;
    overflow:        hidden;
    position:        relative;

    .image {
        background-image:    url('./icons/main.png');
        background-position: right;
        background-repeat:   no-repeat;
        background-size:     160%;
        filter:              blur(10px);
        position:            absolute;
        width:               100vw;
        height:              100vh;
        z-index:             -1;
        overflow:            hidden;
        transform:           scale(1.03);
    }

    .content {
        margin: auto 0;
    }

    .title {
        margin-bottom: 14px;
        color:         #FFFFFF;
        font-size:     32px;
        font-weight:   700;
        line-height:   44px;
    }

    .description {
        color:       #FFFFFF;
        font-size:   24px;
        font-weight: 400;
        line-height: 36px;
    }

    .btn {
        margin-top:      20px;
        display:         flex;
        width:           100%;
        justify-content: center;
        align-items:     center;
        line-height:     28px;
        font-size:       24px;

        .icon {
            transform: rotate(180deg);
        }
    }

    .link {
        color:           #FFFFFF;
        text-decoration: underline;

        &:hover,
        &:active {
            color:           #d2cdcd !important;
            text-decoration: underline !important;
        }
    }


    @media (max-width: 767px) {
        .content {
            padding: 0 20px;
        }

        .image {
            background-size: cover;
            transform:       scale(1.4);
        }

        .title {
            font-size:   24px;
            line-height: 32px;
        }

        .description {
            font-size:   18px;
            line-height: 24px;
        }

        .btn {
            font-size:   20px;
            line-height: 20px;
        }
    }
}
</style>
